import React from 'react';
import { useAppUser } from 'App/components/utils/providers/AppUserProvider';
import { useSettingsServiceApi } from 'Services/settings-service/settings-service';
import { setPublicApiIdentifier } from 'Services/api/public-api-identifier';

/**
 * Sets the public API identifier (public key or tenant slug) so all /publicapi requests
 * receive the correct Bearer token. Must be mounted inside ApiProvider and SettingsServiceApiProvider.
 */
export const PublicApiIdentifierProvider: React.FC<{ children: React.ReactNode }> = ( { children } ) => {
  const currentAccount = useAppUser();
  const settingsServiceApi = useSettingsServiceApi();
  const tenantSlug = currentAccount?.tenantSlug;

  React.useEffect( () => {
    if ( !tenantSlug ) {
      setPublicApiIdentifier( null );
      return;
    }
    setPublicApiIdentifier( tenantSlug );
    if ( !settingsServiceApi ) return;
    let cancelled = false;
    settingsServiceApi.getFirstPublicKey()
      .then( ( publicKey ) => {
        if ( !cancelled ) {
          setPublicApiIdentifier( publicKey ?? tenantSlug );
        }
      } )
      .catch( () => {
        if ( !cancelled ) {
          setPublicApiIdentifier( tenantSlug );
        }
      } );
    return () => {
      cancelled = true;
      setPublicApiIdentifier( null );
    };
  }, [ tenantSlug, settingsServiceApi ] );

  return <>{ children }</>;
};
